import React, { useEffect, useRef } from "react";
import HeroMediaProduction from "./HeroMediaProduction";
import AboutMediaProduction from "./AboutMediaProduction/AboutMediaProduction";
import OurMediaProduction from "./OurMediaProduction/OurMediaProduction";
import WithUs from "../../Landing/WithUs/WithUs";
import Footer from "../../../Components/Footer/Footer";
import MediaProductionPortfolioPart from "./MediaProductionPortfolioPart/MediaProductionPortfolioPart";
import SeoHelmet from "../../../Components/SeoHelmet";

const MediaProduction = () => {
  const scrollRef = useRef(null);
  useEffect(() => {
    scrollRef.current.scrollIntoView();
  }, []);
  return (
    <div className="overflow-hidden">
      <div ref={scrollRef}></div>
      <SeoHelmet
        title="SunMed | Media Production"
        description="SunMed:   We don’t just film — we craft stories. From concept to delivery, our
        team handles video planning, shooting, directing, and post-production
        with seamless coordination. Forget patching together multiple vendors
        we’re your one-stop creative hub."
        keywords="SunMed, media production, web solutions, digital marketing, education, event management"
        url="https://sunmed.com"
        image="https://sunmed.com/images/sunmed-home-og.jpg"
      />
      <HeroMediaProduction />
      <AboutMediaProduction />
      <MediaProductionPortfolioPart />
      <OurMediaProduction />
      <WithUs />
      <Footer />
    </div>
  );
};

export default MediaProduction;
